import React from "react";
import InfoSection from "@components/pages/info/info_section";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Vefþjónusta - {WEBPAGE_TITLE}</title>
            </Head>
            <InfoSection title="Vefþjónusta">
                <p className="text-center">
                    <img
                        src="/img/vefthjonusta.jpg"
                        alt="Vef&thorn;j&oacute;nusta"
                        style={{ width: "100%" }}
                    />
                </p>
                <p className="text-center">
                    Tengdu hugb&uacute;na&eth;arlausnir fyrirt&aelig;kisins vi&eth; gagnagrunn 1819.
                </p>
                <p className="text-center" style={{ paddingBottom: 15 }}>
                    Hr&ouml;&eth;, &ouml;rugg og hagkv&aelig;m lei&eth; sem sparar &thorn;&eacute;r
                    b&aelig;&eth;i t&iacute;ma og peninga.
                </p>
                <h4>
                    <strong>Allar uppl&yacute;singar</strong>
                </h4>
                <p>
                    Veitir a&eth;gang a&eth; &ouml;llum uppl&yacute;singum sem birtar eru vi&eth;
                    leit &aacute; 1819.is. &THORN;essi &thorn;j&oacute;nusta b&yacute;&eth;ur
                    upp&aacute; fj&ouml;lda m&ouml;guleika fyrir vi&eth;skiptavini og kerfi sem
                    &thorn;eir eru me&eth; innanh&uacute;s til &thorn;ess a&eth; f&aacute;
                    n&aacute;nari uppl&yacute;singar um vi&eth;skiptavini s&iacute;na.
                </p>
                <ul style={{ paddingBottom: 15, listStyleType: "circle" }}>
                    <li>M&aacute;na&eth;argjald: 2.300 kr. &aacute;n vsk.</li>
                    <li>Ver&eth; pr. flettingu: 7 kr. &aacute;n vsk.</li>
                </ul>
                <h4>
                    <strong>Nafn &aacute; n&uacute;mer</strong>
                </h4>
                <p>
                    Veitir a&eth;gang a&eth; n&uacute;meri og nafni sem hentar mj&ouml;g vel fyrir
                    s&iacute;mkerfi fyrirt&aelig;kja.
                </p>
                <ul style={{ paddingBottom: 15, listStyleType: "circle" }}>
                    <li>M&aacute;na&eth;argjald: 2.300 kr. &aacute;n vsk.</li>
                    <li>Ver&eth; pr. flettingu: 2 kr. &aacute;n vsk.</li>
                </ul>
                <h4 className="text-center">
                    <strong>Hva&eth; hentar &thorn;&iacute;nu fyrirt&aelig;ki?</strong>
                </h4>
                <p>
                    Haf&eth;u samband vi&eth; okkur &iacute; s&iacute;ma 546 1819 e&eth;a &iacute;
                    gegnum netfangi&eth; 1819@1819.is og vi&eth; finnum lausn sem hentar ykkar
                    &thorn;&ouml;rfum.
                </p>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
